import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import Modal from "react-modal";
import ReactPlayer from "react-player";
import { LuDownload } from "react-icons/lu";

const VideoPlayer = ({ open, closeHandler, videoUrl }) => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = videoUrl;
    link.setAttribute("download", videoUrl.split("/").pop());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Modal
      isOpen={open}
      onRequestClose={closeHandler}
      contentLabel="Video Modal"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          zIndex: "99999",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        content: {
          backgroundColor: "transparent",
          border: "none",
          position: "relative",
          inset: "unset",
          padding: "30px",
        },
      }}
    >
      <AiOutlineClose
        size={25}
        style={{
          position: "absolute",
          cursor: "pointer",
          top: 0,
          color: "#fff",
          right: "26px",
        }}
        onClick={closeHandler}
      />
      <LuDownload
        size={25}
        style={{
          position: "absolute",
          cursor: "pointer",
          top: 0,
          color: "#fff",
          left: "26px",
        }}
        onClick={handleDownload}
      />
      <ReactPlayer
        url={videoUrl}
        playing={open}
        controls={true}
        width="100%"
        height="100%"
      />
    </Modal>
  );
};

export default VideoPlayer;
